import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        tokenType: '='
    },
    template: `
        <div class="well type02 mt2em form">
            <div class="loader01" ng-if="vm.loading">{{ 'question.Please wait' | translate }}</div>
            <ng-container ng-if="!vm.loading">
                <h2 class="h3">{{ 'integration.Generate powerBI token' | translate }}</h2>
                <div class="row" ng-if="!vm.integrationToken">
                    <label class="label" style="min-width: 240px">
                        {{ 'integration.Token expiration date' | translate }}
                        <span class="tooltip-icon" tooltip-append-to-body="true"
                              uib-tooltip="{{ 'integration.integrayion token expire date tooltip' | translate }}"
                        >
                            ?
                        </span>
                    </label>
                    <div class="items">
                        <datepicker-api ng-model="vm.expireDate"></datepicker-api>
                        <button ng-click="vm.generateToken()" class="btn main">
                            {{ 'integration.Generate token' | translate }}
                        </button>
                    </div>
                </div>
                <div ng-if="vm.integrationToken">
                    <div class="row row-wide">
                        <span class="label">
                            {{ 'integration.Your PowerBi Token' | translate }}
                            <span class="tooltip-icon"
                                  tooltip-append-to-body="true"
                                  uib-tooltip="{{ 'integration.Use this token in your powerBI application to query data from Coursy' | translate }}">?</span>
                        </span>
                        <div class="items">
                            <div class="block06 token-display">
                                <code>{{ vm.getBearerToken() }}</code>
                                <a class="ico-copy copy-icon" ng-click="vm.copyToken()"></a>
                            </div>
                        </div>
                    </div>
                    <ul class="actions01">
                        <li>
                            <button class="btn ico-delete small" ng-click="vm.removeToken()" type="button">
                                {{ 'general.Delete' | translate }}
                            </button>
                        </li>
                    </ul>
                </div>
            </ng-container>
        </div>
    `
})

export default class {
    constructor ($translate, lodash, $state, toastr, CompanyResource) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.$state = $state;
        this.toastr = toastr;
        this.CompanyResource = CompanyResource;

        this.expireDate = null;
        this.integrationToken = null;

        this.loading = true;
    }

    $onInit () {
        this.CompanyResource.integrationToken({ type: this.tokenType }).$promise
            .then((response) => {
                if (response.id) {
                    this.integrationToken = response;
                }

                this.loading = false;
            }).finally(() => {
                this.loading = false;
            });
    }

    generateToken () {
        this.loading = true;
        this.CompanyResource.generateIntegrationToken({ expireDate: this.expireDate, type: this.tokenType }).$promise
            .then((response) => {
                this.integrationToken = response;
            }).catch((response) => {
                response.data.forEach((error) => this.toastr.error(error.message));
            }).finally(() => {
                this.loading = false;
            });
    }

    removeToken () {
        this.loading = true;
        this.CompanyResource.removeIntegrationToken({ id: this.integrationToken.id }).$promise
            .then(() => {
                this.integrationToken = null;
                this.loading = false;
            }).finally(() => {
                this.loading = false;
            });
    }

    copyToken () {
        navigator.clipboard.writeText(this.getBearerToken())
            .then(() => this.toastr.success(this.$translate.instant('integration.Token copied')));
    }

    getBearerToken () {
        if (this.integrationToken.token) {
            return `Bearer ${this.integrationToken.token}`;
        }

        return '';
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/settings/integration/generateToken/index.js